import EventsDataStore from '../../datastores/EventsDataStore';

const eventsType = {
  events: [
    // {
    //   idEvent: 1,
    //   name: 'Bienvenida de Cachimbos',
    //   eventImage: 'conferencia-hombre.png',
    //   startDate: 1660521600000,
    //   endDate: 1660521600000,
    //   eventSubtype: {
    //     id: 1,
    //     name: 'Vida Universitaria'
    //   },
    //   eventType: {
    //     id: 2,
    //     name: 'CONFERENCES'
    //   },
    //   modality: 'R',
    //   isOnly: true,
    //   isSubscribed: true,
    //   isFeatured: true,
    //   isToday: false,
    //   isCanceled: false,
    //   isVariedSchedule: false,
    //   schedule: [
    //     {
    //       idDay: 1,
    //       startTime: '18:30',
    //       endTime: '19:30'
    //     }
    //   ]
    // },
    {
      idEvent: 25,
      name: 'Paradigmas de la propiedad intelectual en el siglo Luis',
      eventImage: 'conferencia-hombre.png',
      startDate: 1699632479000,
      endDate: 1699639679000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 1,
        name: 'WORKSHOP'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isCanceled: true,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 29,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI - Abel',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: true,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 2,
      name: 'Bienvenida de Cachimbos',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660521600000,
      endDate: 1660521600000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 1,
          startTime: '08:30',
          endTime: '09:30'
        }
      ]
    },
    {
      idEvent: 10,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 11,
      name: 'Seguridad Industrial en Tiempos de COVID-19',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '17:00',
          endTime: '18:00'
        }
      ]
    },
    {
      idEvent: 13,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 14,
      name: 'Seguridad Industrial en Tiempos de COVID-19',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '17:00',
          endTime: '18:00'
        }
      ]
    },
    {
      idEvent: 15,
      name: 'Salud Mental, la Importancia del Auto Conocimiento y Auto Cuidado Terapeutico',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '16:00',
          endTime: '17:30'
        }
      ]
    },
    {
      idEvent: 16,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 17,
      name: 'Seguridad Industrial en Tiempos de COVID-19',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '17:00',
          endTime: '18:00'
        }
      ]
    },
    {
      idEvent: 18,
      name: 'Salud Mental, la Importancia del Auto Conocimiento y Auto Cuidado Terapeutico',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '16:00',
          endTime: '17:30'
        }
      ]
    },
    {
      idEvent: 19,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 20,
      name: 'Seguridad Industrial en Tiempos de COVID-19',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '17:00',
          endTime: '18:00'
        }
      ]
    },
    {
      idEvent: 21,
      name: 'Salud Mental, la Importancia del Auto Conocimiento y Auto Cuidado Terapeutico',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '16:00',
          endTime: '17:30'
        }
      ]
    },
    {
      idEvent: 22,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 23,
      name: 'Seguridad Industrial en Tiempos de COVID-19',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '17:00',
          endTime: '18:00'
        }
      ]
    },
    {
      idEvent: 24,
      name: 'Salud Mental, la Importancia del Auto Conocimiento y Auto Cuidado Terapeutico',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '16:00',
          endTime: '17:30'
        }
      ]
    },
    {
      idEvent: 26,
      name: 'Seguridad Industrial en Tiempos de COVID-19',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '17:00',
          endTime: '18:00'
        }
      ]
    },
    {
      idEvent: 27,
      name: 'Salud Mental, la Importancia del Auto Conocimiento y Auto Cuidado Terapeutico',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '16:00',
          endTime: '17:30'
        }
      ]
    },
    {
      idEvent: 28,
      name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660780800000,
      endDate: 1660780800000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 4,
          startTime: '19:00',
          endTime: '20:00'
        }
      ]
    },
    {
      idEvent: 12,
      name: 'Salud Mental, la Importancia del Auto Conocimiento y Auto Cuidado Terapeutico',
      eventImage: 'conferencia-hombre.png',
      startDate: 1660867200000,
      endDate: 1660867200000,
      eventSubtype: {
        id: 1,
        name: 'Vida Universitaria'
      },
      eventType: {
        id: 2,
        name: 'CONFERENCES'
      },
      modality: 'R',
      isOnly: true,
      isSubscribed: false,
      isFeatured: false,
      isToday: false,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '16:00',
          endTime: '17:30'
        }
      ]
    }
  ],
  featured: [
    {
      idEvent: 2311,
      name: 'Evento Prueba QA Portal',
      eventImage: 'Manualidades.png',
      startDate: 1661472000000,
      endDate: 1661472000000,
      eventType: {
        id: 1,
        name: 'WORKSHOPS'
      },
      eventSubtype: {
        id: 1,
        name: 'Culturales'
      },
      modality: 'P',
      isOnly: true,
      isSubscribed: false,
      isFeatured: true,
      isToday: true,
      isVariedSchedule: false,
      schedule: [
        {
          idDay: 5,
          startTime: '18:45',
          endTime: '20:15'
        }
      ]
    }
  ]
};

const eventDetail = {
  idEvent: 29,
  name: 'Paradigmas de la propiedad intelectual en el siglo XXI',
  eventImage: 'conferencia-hombre.png',
  startDate: 1699632479000,
  endDate: 1699639679000,
  eventType: {
    id: 2,
    name: 'WORKSHOP'
  },
  eventSubtype: {
    id: 1,
    name: 'Vida Universitaria'
  },
  modality: 'R',
  isOnly: true,
  isSubscribed: false,
  isToday: false,
  isFeatured: false,
  isExist: true,
  isAccessible: true,
  isVariedSchedule: false,
  teacher: 'RAUL SOLORZANO SOLORZANO',
  vacancies: 299,
  schedule: [
    {
      idDay: 4,
      startTime: '19:00',
      endTime: '20:00'
    }
  ],
  scheduleDetail: [],
  organizer: {
    id: 1,
    name: 'Vida Universitaria'
  },
  description:
    'Tema: Paradigmas de la propiedad intelectual en el siglo XXI. Podrás visualizar el enlace zoom de la actividad a través de la app UTP+ o en el Portal del Estudiante. Recuerda que la capacidad es limitada.',
  link: '',
  linkMeet:
    'https://utpvirtual.zoom.us/eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI0NmYzZjRiYy1jZmNmLTU2NGEtYjI1Yy02NGZiMDFhN2VjNjEiLCJyb2xlIjoiU1RVREVOV',
  // linkMeet: null,
  classroom: null,
  flat: null,
  campus: null,
  address: null
};

const responseInscription: any = {
  data: {
    subscribeEvent: {
      status: 'OK',
      data: 'Inscripción registrada con éxito',
      message: 'OK'
    }
  }
};

const responseUnsubscribe: any = {
  data: {
    unSubscribeEvent: {
      status: 'OK',
      data: 'Inscripción anulada con exito',
      message: 'OK'
    }
  }
};

export default class EventsDataStoreMock implements EventsDataStore {
  getOrganizer() {
    throw new Error('Method not implemented.');
  }

  unregisterWaitingList() {
    return { status: 'OK' };
  }

  getPenalties() {
    return '2251,2252';
  }

  registerWaitingList() {
    throw new Error('Method not implemented.');
  }

  getEventsByStudentScroll() {
    throw new Error('Method not implemented.');
  }

  async getEventsByStudent() {
    return eventsType;
  }

  async getEventDetail() {
    return eventDetail;
  }

  async setEventInscription() {
    return {
      eventById: responseInscription
    };
  }

  async setEventUnsubscribe() {
    return {
      eventById: responseUnsubscribe
    };
  }
}
